import {
  type ComponentType,
  createElement,
  type LazyExoticComponent,
  memo,
  type ReactNode,
  StrictMode,
  Suspense,
} from "react";

import {
  type IntersectionOptions,
  useInView,
} from "react-intersection-observer";

import { SectionSettingsProvider } from "./SectionSettingsContext";

interface Props extends Record<string, unknown> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: LazyExoticComponent<ComponentType<any>>;
  observerSettings: IntersectionOptions;
  placeholder: ReactNode;
  sectionId: string | null;
}

const RootBase = ({
  children,
  observerSettings,
  placeholder = <div>Loading...</div>,
  ...shopifySettings
}: Props) => {
  const { inView, ref } = useInView({
    ...observerSettings,
    fallbackInView: true,
    triggerOnce: true,
  });

  return (
    <StrictMode>
      <Suspense fallback={placeholder}>
        <SectionSettingsProvider value={shopifySettings}>
          <div data-intersection-observer ref={ref}>
            {inView ? createElement(children) : placeholder}
          </div>
        </SectionSettingsProvider>
      </Suspense>
    </StrictMode>
  );
};

export const Root = memo(RootBase);
